import { lazy, Suspense } from 'react';

import { Feedback } from 'app/modules/Feedback/Lodeable';
import { TaxpayerHistory } from 'app/modules/Taxpayer/TaxpayerHistory';
import { TaxpayerHistoryDetail } from 'app/modules/Taxpayer/TaxpayerHistory/detail';
import { TaxpayerTaxreturnDetail } from 'app/modules/Taxpayer/TaxpayerTaxReturnDetail/Loadable';
import { TaxpayerTaxReturns } from 'app/modules/Taxpayer/TaxpayerTaxReturns/Loadable';
import { TransactionAdjustment } from 'app/modules/Taxpayer/TransactionAdjustment/Loadable';
import { Route, Routes } from 'react-router-dom';

import RouteAuth from '../../core/security/routeAuth';
import { Role } from '../Security/models/Authorization';

import { CreateCommunication } from './Notification/views/CreateCommunication';
import { TaxpayerReport } from './TaxPayerReport/Loadable';
import { TaxpayerReportDetail } from './TaxPayerReport/TaxPayerReportDetail/Loadable';

const CurrentAccount = lazy(() => import('./CurrentAccount/pages/currentAccount'));
const TaxpayerRequestEvaluation = lazy(
  () => import('./TaxpayerRequestEvaluation/pages/evaluation')
);
const ApproveRequest = lazy(() => import('./TaxpayerRequestEvaluation/pages/approve'));
const RejectRequest = lazy(() => import('./TaxpayerRequestEvaluation/pages/reject'));
const RequestAdditionalInfo = lazy(
  () => import('./TaxpayerRequestEvaluation/pages/requestAdditionalInfo')
);
const TaxpayerReview = lazy(() => import('./TaxpayerRequestEvaluation/components/review'));
const TaxpayerRequest = lazy(() => import('./TaxpayerRequest/pages/request'));
const TaxpayerUpdateRequest = lazy(() => import('./TaxpayerUpdateRequest/pages/updateRequest'));

export const TaxpayerRouting = () => {
  return (
    <Routes>
      <Route
        path="request-evaluation"
        element={
          <RouteAuth access={[Role.TaxpayersApprover]}>
            <Suspense fallback={<></>}>
              <TaxpayerRequestEvaluation />
            </Suspense>
          </RouteAuth>
        }
      />
      <Route
        path="request-evaluation/:id"
        element={
          <RouteAuth access={[Role.TaxpayersApprover]}>
            <Suspense fallback={<></>}>
              <TaxpayerReview />
            </Suspense>
          </RouteAuth>
        }
      />
      <Route
        path="approve-request/:id"
        element={
          <RouteAuth access={[Role.TaxpayersApprover]}>
            <Suspense fallback={<></>}>
              <ApproveRequest />
            </Suspense>
          </RouteAuth>
        }
      />
      <Route
        path="reject-request/:id"
        element={
          <RouteAuth access={[Role.TaxpayersApprover]}>
            <Suspense fallback={<></>}>
              <RejectRequest />
            </Suspense>
          </RouteAuth>
        }
      />

      <Route
        path="request-additional-info/:id"
        element={
          <RouteAuth access={[Role.TaxpayersApprover]}>
            <Suspense fallback={<></>}>
              <RequestAdditionalInfo />
            </Suspense>
          </RouteAuth>
        }
      />
      <Route
        path="request/*"
        element={
          <Suspense fallback={<></>}>
            <TaxpayerRequest />
          </Suspense>
        }
      />
      <Route
        path="update"
        element={
          <Suspense fallback={<></>}>
            <TaxpayerUpdateRequest />
          </Suspense>
        }
      />
      <Route path="tax-returns" element={<TaxpayerTaxReturns />} />

      <Route path="tax-returns/:id" element={<TaxpayerTaxreturnDetail />} />
      <Route
        path="report"
        element={
          <RouteAuth access={[Role.TaxpayerReports, Role.TaxpayersAdmin]}>
            <TaxpayerReport />
          </RouteAuth>
        }
      />

      <Route
        path="report/:id"
        element={
          <RouteAuth access={[Role.TaxpayerReports]}>
            <TaxpayerReportDetail />
          </RouteAuth>
        }
      />

      <Route
        path="current-account"
        element={
          <RouteAuth access={[Role.CurrentAccountAdmin]}>
            <Suspense fallback={<></>}>
              <CurrentAccount />
            </Suspense>
          </RouteAuth>
        }
      />

      <Route path="feedback" element={<Feedback />} />
      <Route path="transaction-adjustment" element={<TransactionAdjustment />} />
      <Route
        path="history"
        element={
          <RouteAuth access={[Role.TaxpayersAdmin, Role.TaxpayerReports]}>
            <TaxpayerHistory />
          </RouteAuth>
        }
      />

      <Route
        path="history/:id"
        element={
          <RouteAuth access={[Role.TaxpayersAdmin]}>
            <TaxpayerHistoryDetail />
          </RouteAuth>
        }
      />
      <Route path="create-communication" element={<CreateCommunication />} />
    </Routes>
  );
};
